import {useState} from "react";
import TmCreateModeComponent from "./TmCreateModeComponent";
import TmRunModeComponent from "./TmRunModeComponent";
import '../../styles/TmSimulatorPage.css';
import {areArraysEqual} from "../../js/utils";
import NavBar from "../components/NavBar";

export default function TmSimulatorPage(){
    // current mode
    const [currentMode, setCurrentMode] = useState('CREATE'); // CREATE, RUN


    // state of CREATE mode
    const [createModeState, setCreateModeState] = useState({
        // alphabet inputs
        alphabetChars: [],                              // string[]
        alphabetCharsInputErrors: [],                   // TmParsingError[]
        alphabetEmptyCellChar: '',                      // string (length=1)

        // states inputs
        statesInputs: [
            {
                name: '',
                description: '',
                final: false
            }
        ],
        uniqueValidStatesNames: [],                     // string[] (took from statesInputs; used in transitions rules inputs
        initialStateInputId: undefined,                 // string, in the format, returned by getStateInputId(index)
        statesInputsErrors: [[]],                       // TmParsingError[][]

        // transition rules inputs
        transitionRulesInputs: [
            {
                startState: '',                         // string
                lookedChar: '',                         // string (length=1)
                endState: '',                           // string
                charToWrite: '',                        // string (length=1)
                headDirection: 'NONE'                   // string (NONE/LEFT/RIGHT)
            }
        ],

        // switch to RUN mode handling
        switchToRunModeErrors: []                       // TmParsingError[]
    });

    // state of RUN mode
    const [runModeState, setRunModeState] = useState({
        alphabet: undefined,                            // TmAlphabet
        states: undefined,                              // TmState[]
        initialState: undefined,                        // TmState
        finalStates: undefined,                         // TmState[]
        transitionsRelation: undefined,                 // TmTransitionsRelation

        wordInput: '',                                  // string
        wordInputErrors: [],                            // TmParsingError[] (empty, or char not in character alphabet)
        initialWordOnTape: '',                          // string; need this var, because it helps initialize Turing machine

        history: [],                                    // TmMemento[] // if it is empty, when it is no word on tape (can't make calculations)
        currentIndexInHistory: undefined,               // number
        stepsLimit: 100                                 // number (steps limit when execute up to final state), max is 1,000
    });

    /**
     * Changes current mode from CREATE to RUN.
     *
     */
    const handleSwitchToRunMode = (states, alphabet, transitionsRelation, initialState, finalStates) => {
        console.log("Moved to RUN state");
        console.log(alphabet.toString());
        console.log("States: " + states.map(s => s.name).join(' '));
        console.log("Initial state: " + initialState.name);
        console.log("Final states: " + finalStates.map(s => s.name).join(' '));
        console.log("Transitions relation:\n" + transitionsRelation.toString());


        // if first time entering RUN mode or something is changed since last entering, then init from start
        if(!runModeState.alphabet || !runModeState.states || !runModeState.initialState ||
            !runModeState.finalStates || !runModeState.transitionsRelation ||
            !areTmStatesArraysEqual(states, runModeState.states) || !alphabet.equals(runModeState.alphabet) ||
            !initialState.equals(runModeState.initialState) || !areTmStatesArraysEqual(finalStates, runModeState.finalStates) ||
            !transitionsRelation.equals(runModeState.transitionsRelation)) {

            // init runModeState by new entities
            setRunModeState((state) => ({
                alphabet: alphabet,
                states: states,
                initialState: initialState,
                finalStates: finalStates,
                transitionsRelation: transitionsRelation,

                wordInput: '',
                wordInputErrors: [],
                initialWordOnTape: '',

                history: [],
                currentIndexInHistory: undefined,
                stepsLimit: 100
            }));
        }
        // else, nothing has changed since last entering RUN mode,
        // so any initializations are required

        setCurrentMode((mode) => 'RUN');
    }

    const handleSwitchToCreateMode = () => {
        setCurrentMode((mode) => 'CREATE');
    }

    const areTmStatesArraysEqual = (arr1, arr2) => {
        return areArraysEqual(arr1.map(s => s.name).sort(), arr2.map(s => s.name).sort());
    }



    return (
        <>
            <NavBar activeTab={'tm'}/>

            <div className={'container mt-2'}>
                <h1>TM Simulator</h1>

                {(currentMode === 'CREATE') ? (
                    <TmCreateModeComponent
                        createModeState={createModeState}
                        setCreateModeState={setCreateModeState}
                        switchToRunMode={handleSwitchToRunMode}
                    />
                ) : (
                    <TmRunModeComponent
                        runModeState={runModeState}
                        setRunModeState={setRunModeState}
                        switchToCreateMode={handleSwitchToCreateMode}/>
                )}
            </div>
        </>
    );
}